import React from "react";
import { cn } from "@/lib/utils";

// Text-only testimonial card — NO photos, by design.
export const TestimonialCard = ({ item, className, size = "md" }) => (
  <figure
    className={cn(
      "group relative flex h-full flex-col overflow-hidden rounded-[24px] border border-white/[0.08] bg-white/[0.03] p-7 backdrop-blur-xl transition-[border-color,transform] duration-500 hover:-translate-y-1 hover:border-axor-cyan/25",
      className,
    )}
    data-testid={`testimonial-${item.name.toLowerCase().replace(/\s/g, "-")}`}
  >
    {/* Large decorative quotation mark */}
    <span
      aria-hidden="true"
      className="pointer-events-none absolute -right-2 -top-6 select-none font-serif text-[9rem] leading-none text-axor-cyan/10 transition-colors duration-500 group-hover:text-axor-cyan/20"
    >
      &rdquo;
    </span>
    <div className="absolute right-6 top-6 h-8 w-8 opacity-40">
      <svg viewBox="0 0 40 40" className="h-full w-full">
        <polygon points="20,4 36,34 4,34" fill="none" stroke="#16B8D4" strokeWidth="1" />
      </svg>
    </div>

    <blockquote
      className={cn(
        "relative font-medium leading-relaxed text-axor-white/85",
        size === "lg" ? "text-xl" : "text-base",
      )}
    >
      {item.testimonial}
    </blockquote>

    <figcaption className="mt-auto border-t border-white/[0.06] pt-5">
      <div className="text-base font-semibold text-axor-white">{item.name}</div>      <div className="text-sm text-axor-cyan">{item.role}</div>
      {item.location && (
        <div className="mt-0.5 text-xs text-axor-text">{item.location}</div>
      )}
    </figcaption>
  </figure>
);
